import { useState } from 'react'
import PropTypes from 'prop-types'
import styles from './Avatar.module.css'

const SIZES = [24, 32, 40, 56, 112]

export function Avatar({ src, alt = 'Avatar', initials, size = 40, className = '' }) {
  const [imgError, setImgError] = useState(false)

  const showPhoto = Boolean(src) && !imgError
  const showInitial = !showPhoto && Boolean(initials)
  const variant = showPhoto ? 'photo' : showInitial ? 'initial' : 'empty'

  const classes = [
    styles.avatar,
    styles[`avatar--${size}`],
    styles[`avatar--${variant}`],
    className,
  ].filter(Boolean).join(' ')

  return (
    <div className={classes}>
      {showPhoto && (
        <img
          className={styles.avatar__img}
          src={src}
          alt={alt}
          onError={() => setImgError(true)}
        />
      )}
      {showInitial && (
        <span className={styles.avatar__initial}>{initials}</span>
      )}
    </div>
  )
}

Avatar.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  initials: PropTypes.string,
  size: PropTypes.oneOf(SIZES),
  className: PropTypes.string,
}
